// Configuración del servidor
const getServerUrl = () => {
  // Usar variable de entorno si está disponible
  if (import.meta.env.VITE_SERVER_URL) {
    return import.meta.env.VITE_SERVER_URL
  }
  
  // Si estamos en desarrollo local
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8888'
  }
  
  // Si estamos en producción
  return 'https://gophonetv.pro'
}

const getApiUrl = () => {
  // Usar variable de entorno si está disponible
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }
  
  return getServerUrl() + '/api'
}

export const config = {
  serverUrl: getServerUrl(),
  apiUrl: getApiUrl()
} 